export const donorService = (request) => {
  
  const DONOR_API_ENDPOINT = '/service/liquidlove/donors';
  //const DONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/donors';

  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.donor)
  };

  return fetch(DONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const updateDonorService = (request) => {
  
  const UPDATE_DONOR_API_ENDPOINT = '/service/liquidlove/updateDonor';
  //const UPDATE_DONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/updateDonor';

  const parameters = {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + request.donor.token,      
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.donor.data)
  };

  return fetch(UPDATE_DONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const selfserviceDonorService = (request) => {
  
  const SELFSERVICE_DONOR_API_ENDPOINT = '/service/liquidlove/donor/selfservice';
  //const SELFSERVICE_DONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/donor/selfservice';

  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.donor.data)
  };

  return fetch(SELFSERVICE_DONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const notifyDonorsService = (request) => {
  
  const NOTIFY_DONORS_API_ENDPOINT = '/service/liquidlove/notify/' + request.notifyPayload.requestId   + '?size=' + request.notifyPayload.size + '&page=' + request.notifyPayload.pageNum + '&countryFilter=' + request.notifyPayload.country + '&stateLocationFilter=' + request.notifyPayload.stateLocation + '&districtFilter=' + request.notifyPayload.districtFilter + '&localityFilter=' + request.notifyPayload.localityFilter;
  //const NOTIFY_DONORS_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/notify/' + request.notifyPayload.requestId  + '?size=' + request.notifyPayload.size + '&page=' + request.notifyPayload.pageNum + '&countryFilter=' + request.notifyPayload.country + '&stateLocationFilter=' + request.notifyPayload.stateLocation + '&districtFilter=' + request.notifyPayload.districtFilter + '&localityFilter=' + request.notifyPayload.localityFilter;
  
  const parameters = {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + request.notifyPayload.token,      
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.notifyPayload.matchingDonors)
  };

  return fetch(NOTIFY_DONORS_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchAllDonorsService = (request) => {
  
  const ALL_DONORS_FETCH_API_ENDPOINT = '/service/liquidlove/donors/find?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&filter=' + encodeURIComponent(request.payload.filter) + '&isActive=' + request.payload.isActive;
  //const ALL_DONORS_FETCH_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/donors/find?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&filter=' + encodeURIComponent(request.payload.filter) + '&isActive=' + request.payload.isActive;
    
  const parameters = {
    method: 'GET',
    headers: {      
      'Authorization': 'Bearer ' + request.payload.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(ALL_DONORS_FETCH_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchDonorByPhoneService = (request) => {
  
  const FETCHDONORBYPHONE_API_ENDPOINT = '/service/liquidlove/donors/findbyphone?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&phone=' + encodeURIComponent(request.payload.phone);
  //const FETCHDONORBYPHONE_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/donors/findbyphone?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&phone=' + encodeURIComponent(request.payload.phone);
    
  const parameters = {
    method: 'GET',
    headers: {      
      'Authorization': 'Bearer ' + request.payload.token,
      'Content-Type': 'application/json'
    },    
  };

  return fetch(FETCHDONORBYPHONE_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const addVolunteerDonorService = (request) => {
  
  const ADDVOLUNTEERDONOR_API_ENDPOINT = '/service/liquidlove/addVolunteerDonor/patient/' + request.payload.requestId + '/donor/' + request.payload.volunteerDonor + '?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&countryFilter=' + request.payload.country + '&stateLocationFilter=' + request.payload.stateLocation + '&districtFilter=' + request.payload.districtFilter + '&localityFilter=' + request.payload.localityFilter;
  //const ADDVOLUNTEERDONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/addVolunteerDonor/patient/' + request.payload.requestId + '/donor/' + request.payload.volunteerDonor + '?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&countryFilter=' + request.payload.country + '&stateLocationFilter=' + request.payload.stateLocation + '&districtFilter=' + request.payload.districtFilter + '&localityFilter=' + request.payload.localityFilter;
    
  const parameters = {
    method: 'GET',
    headers: { 
      'Authorization': 'Bearer ' + request.payload.token,     
      'Content-Type': 'application/json'
    },    
  };

  return fetch(ADDVOLUNTEERDONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const deleteVolunteerDonorService = (request) => {
  
  const DELETEVOLUNTEERDONOR_API_ENDPOINT = '/service/liquidlove/deleteVolunteerDonor/patient/' + request.payload.requestId + '/donor/' + request.payload.volunteerDonor + '?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&countryFilter=' + request.payload.country + '&stateLocationFilter=' + request.payload.stateLocation + '&districtFilter=' + request.payload.districtFilter + '&localityFilter=' + request.payload.localityFilter;
  //const DELETEVOLUNTEERDONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/deleteVolunteerDonor/patient/' + request.payload.requestId + '/donor/' + request.payload.volunteerDonor + '?size=' + request.payload.size + '&page=' + request.payload.pageNum + '&countryFilter=' + request.payload.country + '&stateLocationFilter=' + request.payload.stateLocation + '&districtFilter=' + request.payload.districtFilter + '&localityFilter=' + request.payload.localityFilter;
    
  const parameters = {
    method: 'DELETE',
    headers: { 
      'Authorization': 'Bearer ' + request.payload.token,     
      'Content-Type': 'application/json'
    },    
  };

  return fetch(DELETEVOLUNTEERDONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const addActualDonorService = (request) => {
  
  const ADDACTUALDONOR_API_ENDPOINT = '/service/liquidlove/addActualDonor';
  //const ADDACTUALDONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/addActualDonor';
    
  const parameters = {
    method: 'POST',
    headers: { 
      'Authorization': 'Bearer ' + request.payload.token,     
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.payload)    
  };

  return fetch(ADDACTUALDONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const importDonorsService = (request) => {
  
  const IMPORTDONOR_API_ENDPOINT = '/service/liquidlove/import/donors';
  //const IMPORTDONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/import/donors';
  
  const formData = new FormData();
  formData.append('file', request.payload.file);  
  const parameters = {
    method: 'POST',
    headers: { 
      'Authorization': 'Bearer ' + request.payload.token
    },
    body: formData
  };

  return fetch(IMPORTDONOR_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const sendOTPDonorService = (request) => {

    const SENDOTPDONOR_API_ENDPOINT = '/service/liquidlove/donors/' + request.payload.phone + '/send-otp';
    //const SENDOTPDONOR_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/donors/' + request.payload.phone + '/send-otp';
    const parameters = {
      method: 'POST'
    };

    return fetch(SENDOTPDONOR_API_ENDPOINT, parameters)
      .then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
};